import keywordsService from "@/services/keywords";
import serviceHandler from "@/helpers/handlers/service";

import { KEYWORDS_SCOPE } from "@/enums/keywords";

export default {
  async fetchKeywords({ commit, state }, params = {}) {
    const { scope } = state;
    const scopeHandlers = {
      [KEYWORDS_SCOPE.COMPANY]: async () => {
        return await serviceHandler(keywordsService.getCompanyKeywords(params));
      }
      // TODO: add group and facility scope handlers
    };
    const response = await scopeHandlers[scope]();
    commit("SET_KEYWORDS", response || []);
  },

  async addKeyword({ state, dispatch }, payload) {
    const { scope } = state;
    const scopeHandlers = {
      [KEYWORDS_SCOPE.COMPANY]: async payload => {
        return await serviceHandler(
          keywordsService.postCompanyKeyword(payload)
        );
      }
      // TODO: add group and facility scope handlers
    };

    await scopeHandlers[scope](payload);
    await dispatch("fetchKeywords");
  },

  async deleteKeyword({ state, dispatch }, keywordId) {
    const { scope } = state;
    const scopeHandlers = {
      [KEYWORDS_SCOPE.COMPANY]: async keywordId => {
        return await serviceHandler(
          keywordsService.deleteCompanyKeyword(keywordId)
        );
      }
      // TODO: add group and facility scope handlers
    };

    await scopeHandlers[scope](keywordId);
    await dispatch("fetchKeywords");
  }
};
